<template>
  <div id="parts-responsive" class="parts-modal">
    <div class="episode-header">
      {{ this.part_titles[episode_index]["title"] }}
    </div>
    <div class="parts-container">
      <div
        v-for="part in this.parts[episode_id]"
        class="parts"
        @click="
          $store.commit('updateChunkPlayback', part.chunk);
          $store.commit('updatePart', part.id);
        "
        :key="part.section"
        :id="part.id"
      >
        {{ part.section }}
      </div>
    </div>
  </div>
</template>

<script>
import episode_parts from "../data/parts_episode.json";
import { mapState } from "vuex";
import ecchr_config from "../data/ecchr_config.json";

export default {
  name: "PartsExpisode",
  data() {
    return {
      parts: episode_parts,
      part_titles: ecchr_config["episode_cards"],
    };
  },
  computed: {
    ...mapState([
      "episode_id",
      "currentPart",
      "lastPart",
      "episode_index",
      "device_mode",
    ]),
  },
  methods: {},
  watch: {
    device_mode: function (device_mode) {
      const partsResponsive = document.getElementById("parts-responsive");
      if (device_mode == "mobile") {
        partsResponsive.style.width = "100%";
        partsResponsive.style.height = "90vh";
        partsResponsive.classList.remove("parts-desktop");
        partsResponsive.classList.add("parts-mobile");
      } else {
        partsResponsive.style.width = "375px";
        partsResponsive.style.height = "593px";
        partsResponsive.classList.remove("parts-mobile");
        partsResponsive.classList.add("parts-desktop");
      }
    },
    // episode_id: function (val) {
    //   const last = this.parts[val].length - 1;
    //   console.log(last);
    //   this.$store.commit("updateLastPart", last);
    // },
    currentPart: function (val) {
      const parts = document.querySelectorAll(".parts");
      parts.forEach((element) => {
        element.classList.remove("part-selected");
      });

      const element = document.getElementById(val);
      if (element.id == val) {
        element.classList.add("part-selected");
      }
    },
  },
  mounted() {
    const partsResponsive = document.getElementById("parts-responsive");
    if (this.device_mode == "mobile") {
      partsResponsive.style.width = "100%";
      partsResponsive.style.height = "90vh";
      partsResponsive.classList.remove("parts-desktop");
      partsResponsive.classList.add("parts-mobile");
    } else {
      partsResponsive.style.width = "375px";
      partsResponsive.style.height = "593px";
      partsResponsive.classList.remove("parts-mobile");
      partsResponsive.classList.add("parts-desktop");
    }
  },
};
</script>

<style scoped>
.parts-modal {
  overflow-y: scroll;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background-color: rgba(44, 44, 46, 0.3);
  z-index: 1;
}

.parts-mobile {
  position: fixed;
  top: 0px;
}

.parts-desktop {
  position: sticky;
  top: 0;
}

.parts-container {
  padding-top: 40px;
  display: grid;
  grid-template-rows: repeat(40px);
}
.parts {
  display: grid;
  background-color: rgb(44, 44, 46);
  height: 60px;
  width: 70%;
  place-self: center;
  margin-bottom: 20px;
  border-radius: 8px;
  padding-left: 30px;
  align-content: center;
  transition: 0.2s ease-in-out;
}
.parts:hover {
  cursor: pointer;
  background-color: rgb(65, 65, 65);
}

.part-selected {
  background-color: rgb(105, 105, 105);
  transition: 0.2s ease-in-out;
}

.episode-header {
  width: 70%;
  font-size: 20px;
  margin-top: 50px;
  margin-left: 50px;
  margin-right: 50px;
  font-weight: 700;
}
</style>